










































































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'Activations'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'
      fetch: false
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'
      fetch: false

  vue:
    props: ['offer', 'step']

    data: ->
      openPanel: null

    computed:
      audienceListingId: -> @ctxAudienceListing(@offer).id
      audienceListing: -> @audience_listing

      vendorListingId: -> @ctxVendorListing(@offer).id
      vendorListing: -> @vendor_listing

export default VueOptions.vue settings
